exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.module-rule[data-v-c2140432] {\n  position: relative;\n}\n.module-rule .content[data-v-c2140432] {\n  padding: 10px;\n}\n.module-rule .content ul li[data-v-c2140432] {\n  margin-bottom: 10px;\n  color: #666666;\n}\n.module-rule .content ul .title[data-v-c2140432] {\n  height: 25px;\n  width: 83px;\n  background-color: #f9b05b;\n  color: #fff;\n  border-radius: 10.25px;\n  line-height: 25px;\n  text-align: center;\n  font-size: 14px;\n}\n", ""]);

// exports
